import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Image,
    Box
} from "@chakra-ui/react";

/**
 * ImageModal component for displaying larger versions of statistical images
 * 
 * @param {boolean} isOpen - Controls whether the modal is visible
 * @param {function} onClose - Function to call when closing the modal
 * @param {string} imageSrc - Source URL of the image to display
 * @param {string} title - Title of the image to display in the modal header
 */
export default function ImageModal({ isOpen, onClose, imageSrc, title }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl" closeOnOverlayClick={false}>
            <ModalOverlay
                bg="blackAlpha.300"
                backdropFilter="blur(10px)"
            />
            <ModalContent bg="#f6f3ec" borderColor="#0b4e5a" borderWidth="2px" o>
                <ModalHeader color="#0b4e5a">{title}</ModalHeader>
                <ModalCloseButton mt={2}/>
                <ModalBody>
                    <Box
                        p={2}
                        bg="white"
                        borderRadius="md"
                        shadow="md"
                        width="100%"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Image
                            src={imageSrc}
                            alt={title}
                            objectFit="contain"
                            maxH="60vh" // Maximum height relative to viewport height 70vh current
                            width="100%"
                        />
                    </Box>
                </ModalBody>

                {/* <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter> */}
            </ModalContent>
        </Modal>
    );
}